import { createContext } from "react";

export interface AtsIntegration {
  tokens: string[];
  report_url_type: string;
  default_package_id: string;
  trigger_stage: string;
  customer_group_id: string;
}

export interface UnifiedConfig {
  connection_id: string;
}

export interface UnifiedIntegrationContextType {
  atsIntegrationData: AtsIntegration;
  unifiedConfig: UnifiedConfig | null;
  currentStep: number;
  setAtsIntegration: (atsIntegrationData: AtsIntegration) => void;
  setUnifiedConfig: (unifiedConfig: UnifiedConfig) => void;
  goToNextStep: () => void;
  goToPrevStep: () => void;
}

export const UnifiedIntegrationContext =
  createContext<UnifiedIntegrationContextType>({
    atsIntegrationData: {
      tokens: [],
      report_url_type: "",
      default_package_id: "",
      trigger_stage: "",
      customer_group_id: "",
    },
    setAtsIntegration: (newState: AtsIntegration) => newState,
    unifiedConfig: null,
    setUnifiedConfig: (unifiedConfig: UnifiedConfig) => unifiedConfig,
    currentStep: 0,
    goToNextStep: () => {},
    goToPrevStep: () => {},
  });
